<template>
  <div class="box">
    <p class="title">{{ $route.query.title }}</p>
    <p style="padding:1rem;color:#999;">
      <span style="color:#000;">{{ $route.query.name }}</span> 作品
    </p>

    <div class="bottom">
      <iframe :src="src_id" scrolling="no"> </iframe>
    </div>

    <div class="direction" v-if="false">
      <div class="left">
        <div class="top_but">
          <i class="el-icon-caret-top"></i>
        </div>
        <div class="right_but">
          <i class="el-icon-caret-right"></i>
        </div>
        <div class="down_but">
          <i class="el-icon-caret-bottom"></i>
        </div>
        <div
          class="left_but"
          @click="regKeyEvent('.button_left', 'ArrowLeft', 37)"
        >
          <i class="el-icon-caret-left"></i>
        </div>
      </div>
      <div class="right" @click="regKeyEvent('.button_space', ' ', 32)">
        <p>空格</p>
      </div>
    </div>

    <div class="img_box">
      <img src="../../assets/stylus/image/app.jpeg" />
    </div>

    <div class="fixed_banner">
      <div style="display: flex;justify-content: center;align-items: center;">
        <div class="img"></div>
        <div class="text">
          互动编程课 + 3款编程作品
        </div>
        <div class="but" @click="to_router">跟我一起学</div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

$(document).ready(function() {
  $("p").click(function() {
    $(this).hide();
  });
});
export default {
  data() {
    return {
      form: {},
      src_id: "",
    };
  },

  created() {
    this.form = this.$route.query;
    // this.src_id = "/scratch/?stageArea=true&id=" + this.$route.query.value;
    this.src_id = "/scratch/?stageArea=true&app=" + this.$route.query.value;
  },
  methods: {
    regKeyEvent(selector, key, keyCode) {
      console.log("注册按键事件:" + key);
      $(selector).on("touchstart", function(event) {
        vm.postIOData("keyboard", {
          keyCode: keyCode,
          key: key,
          isDown: true,
        });
        event.preventDefault();
      });
      $(selector).on("touchend", function() {
        vm.postIOData("keyboard", {
          keyCode: keyCode,
          key: key,
          isDown: false,
        });
        event.preventDefault();
      });
    },

    // 跳转
    to_router() {
      this.$router.push({ path: "/app_iphone" });
    },
  },
};
</script>

<style lang="stylus" scoped>
.box {
    // padding:1rem;
}
.title {
  font-size:1.4rem;
  padding:1rem;
}
.bottom {
  background:#ccc;
  height:20rem;
  width:100%;
  margin-top:1rem;
}
 iframe {
          width:100%;
          height:100%;
        }
.key {
    margin-top:10rem;
    background:#ccc;
    width:4rem;
    height:4rem;
}
.direction {
    margin-top:2rem;
    width:100%;
    height:16rem;
    display: flex;
    justify-content:space-between;
    position: relative;
    .left {
        width:56%;
        position: relative;
        .top_but {
          width:6rem;
          height:6rem;
          border-radius:5rem;
          background:#333;
          position: relative;
          position: absolute;
          left:50%;
          transform: translateX(-50%);

          .el-icon-caret-top {
            color: white;
            font-size: 3rem;
            position: absolute;
            left:50%;
            top:50%;
            transform: translate(-50% , -50%);
          }
        }
        .right_but {
          width:6rem;
          height:6rem;
          border-radius:5rem;
          background:#333;
          position: relative;
          position: absolute;
          right:0%;
          top:50%;
          transform: translateY(-50%);
        .el-icon-caret-right {
            color: white;
            font-size: 3rem;
            position: absolute;
            left:50%;
            top:50%;
            transform: translate(-50% , -50%);
          }
        }
        .down_but {
          width:6rem;
          height:6rem;
          border-radius:5rem;
          background:#333;
          position: relative;
          position: absolute;
          left:50%;
          bottom: 0;
          transform: translateX(-50%);
          .el-icon-caret-bottom {
            color: white;
            font-size: 3rem;
            position: absolute;
            left:50%;
            top:50%;
            transform: translate(-50% , -50%);

          }
        }
        .left_but {
          width:6rem;
          height:6rem;
          border-radius:5rem;
          background:#333;
          position: relative;
          position: absolute;
          left:0;
          top: 50%;
          transform: translateY(-50%);
          .el-icon-caret-left {
            color: white;
            font-size: 3rem;
            position: absolute;
            left:50%;
            top:50%;
            transform: translate(-50% , -50%);
          }
        }
    }
    .right{
        width:7rem;
        height:7rem;
        border-radius:50%;
        background:#333;
        position:absolute;
        top:50%;
        right:0;
        transform: translateY(-50%);
        p {
            font-size:1.6rem;
            text-align: center;
            line-height: 7rem;
            color:white;
        }
    }
}

.img_box {
    margin-top:4rem;
    padding:1rem;
    padding-bottom:6rem;
    width:100%;
    background:#fff;
    img {
        width:100%;
    }
}

.fixed_banner {
    border-radius:1rem 1rem 0rem 0rem;
    width:100%;
    background:#3379fe;
    color:white;
    padding:1rem;
    position: fixed;
    bottom:0;
    .text {
       font-size:1rem;
       text-align: center;
    //    position: absolute;
    //    left: 50%;
    //    top: 50%;
    //    transform: translateX(-50%);
    //    margin-top: 20%;
    }
    .but {
       float:right;
       padding:0.5rem;
       background: #f4374a;
       border-radius:2rem;
       position:relative;
       margin-left:4rem;
       animation:mymove 3s infinite;
       -webkit-animation:mymove 3s infinite; /*Safari and Chrome*/
       animation-direction:alternate;/*轮流反向播放动画。*/
       animation-timing-function: ease-in-out; /*动画的速度曲线*/
       -webkit-animation:mymove 3s infinite;
       -webkit-animation-direction:alternate;/*轮流反向播放动画。*/
       -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
    }

    @keyframes mymove {
                0%{
                transform: scale(1);  /*开始为原始大小*/
                }
                25%{
                    transform: scale(1.2); /*放大1.1倍*/
                }
                50%{
                    transform: scale(1);
                }
                75%{
                    transform: scale(1.2);
                }
            }
}
</style>
